import store from './store'
import router from './router'
import Cookies from 'js-cookie'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'
// import { deepClone } from './utils'
import { setHistoryPath } from './utils/router'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/qywx/zhenti', '/qywx/jianzhi', '/qywx/basic', '/books/book_ocr_edit'] // no redirect whitelist
const forceHttpsList = ['/ehafo_kanban/index'] // 需要https强跳的页面
// 跳转登录页
const navToLogin = (next) => {
  const redirectPath = window.location.pathname + window.location.search
  localStorage.setItem('loginRedirect', redirectPath)
  next('/login')
}
router.beforeEach(async (to, from, next) => {
  if (forceHttpsList.indexOf(to.path) > -1 && process.env.NODE_ENV !== 'development' && location.protocol === 'http:') {
    // https强跳
    location.href = location.href.replace('http:', 'https:')
    return
  }
  // start progress bar
  NProgress.start()
  // 有token时

  if (whiteList.indexOf(to.path) !== -1) {
    if (store.getters['user/qywxUserid'] === '') {
      // 设置企业微信侧边栏进入时的id
      await store.dispatch('user/setQywxUserid', to.query.qywx_userid)
    }
    next()
  } else {
    // 有无用户数据
    if (store.getters['user/userid'] === '') {
      let userid = Cookies.get('userid')
      if (!userid) {
        userid = await store.dispatch('user/getUserid')
      }
      // console.log(userid)
      // cookie中是否存在userid
      if (userid) {
        // 在vuex中存入userid
        await store.dispatch('user/setUserId', userid)
        const hidden = to.query.hidden
        await store.dispatch('settings/setHidden', hidden)
        const markhidden = to.query.__hidden
        await store.dispatch('settings/setMarkHidden', markhidden)
        // 获取全部角色列表
        await store.dispatch('auth/getgroups')
        // 获取用户信息

        const res = await store.dispatch('user/getUserInfo')
        if (res === false) {
          await store.dispatch('user/logout')
          navToLogin(next)
          return
        }
        // 获取动态路由表
        const addRouters = await store.dispatch('routes/GenerateRoutes')
        // console.log(addRouters)
        addRouters.forEach((route) => {
          if (route.isGroup) {
            if (route.children && route.children.length > 0) {
              route.children.forEach((childrenRoute) => {
                router.addRoute(childrenRoute) // 动态添加可访问路由表
              })
            }
          } else {
            router.addRoute(route) // 动态添加可访问路由表
          }
        })
        next({
          ...to,
          replace: true,
        }) // hack方法 确保addRoutes已完成
      } else {
        navToLogin(next)
      }
    } else {
      let hidden = store.getters['settings/hidden']
      if (to.meta && to.meta.hideMenu && !hidden) {
        // 菜单配置中设置了隐藏菜单，修改vuex中的hidden
        hidden = '1'
        await store.dispatch('settings/setHidden', hidden)
      }
      const query = to.query
      if (hidden && (!query.hidden || query.hidden == 0)) {
        // 如果vuex中的hidden为true，则设置query中的hidden为1
        query.hidden = '1'

        // 如果vuex中的__hidden为true，则设置query中的__hidden为1
        let markhidden = store.getters['settings/markhidden']
        if (markhidden) {
          query.__hidden = '1'
        }
        next({
          ...to,
          query,
        })
      } else {
        if (to.path === '/question_neaten') {
          // 前往新题整理系统，进行权限限制
          let limitUid = ['439', '67', '47', '255', '256']
          if (localStorage.env_model === 'prod') {
            // 如果是正式环境
            // 47-梁雪燕 53-伏莎莎 67-吴宣 82-顾杰 93-姚露梦 191-王涛 256-陈益波 439-王志龙
            limitUid = ['47', '53', '67', '82', '93', '191', '256', '439']
          }
          const userId = store.getters['user/userid']
          if (limitUid.indexOf(userId) === -1) {
            next('/404')
          } else {
            next()
          }
        } else {
          next()
        }
      }
    }
  }
})

router.afterEach((to) => {
  let title = ''
  let tab = to.query.tab
  if (to.meta.tabUrl) {
    if (!tab) {
      tab = Object.keys(to.meta.tabArr)[0]
    }
    title = to.meta.tabArr[tab] || to.meta.title || '易哈佛后台管理'
  } else if (to.meta.tabName) {
    if (!tab) {
      tab = Object.keys(to.meta.tabName)[0]
    }
    title = to.meta.tabName[tab] || to.meta.title || '易哈佛后台管理'
  } else {
    title = to.meta.title || '易哈佛后台管理'
  }
  document.title = title
  if (window.parent !== window) {
    // 被iframe嵌套则改变其标题
    window.parent.postMessage({ title, query: to.query }, '*')
  }
  const viewportTag = document.querySelector('meta[name="viewport"]')
  if (to.meta.viewport) {
    if (viewportTag) {
      viewportTag.setAttribute('content', to.meta.viewport)
    } else {
      const newViewportTag = document.createElement('meta')
      newViewportTag.name = 'viewport'
      newViewportTag.content = to.meta.viewport
      document.head.appendChild(newViewportTag)
    }
  } else if (viewportTag) {
    // 没有设置，则直接移除已有的
    viewportTag.remove()
  }
  // 缓存历史查看
  setHistoryPath(to)
  // finish progress bar
  NProgress.done()
})
